<template>
    <WalletHeader/>
    <router-view v-if="init" :key="$route.fullPath"></router-view>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { computed } from 'vue';
import { getWalletAuth , getStakes} from '@template/utils';
import WalletHeader from '../components/WalletHeader.vue';
export default {
    name: "WalletModule",
    data() {
        return {
            init: false,
            config: null,
            walletData: null
        }
    },
    provide() {
        return {
            walletConfig : computed(() => this.config),
            // walletData : computed(() => this.walletData),
            // onlyBank: computed(() => !!this.config?.agents.find(agent => agent == this.$auth.user.cpi) || false),
            // getStakes : this.getStakes
        }
    },
    components: {
        WalletHeader
    },
    created(){
        this.getWalletAuth();
        // this.getStakes();
    },
    methods:{
        async getWalletAuth(){
            try {
                let response = await getWalletAuth();
                if(response?.data){
                    this.config = response.data
                    this.init = true
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
        async getStakes(){
            try {
                let response = await getStakes();
                if(response?.data){
                    this.walletData = response.data
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
    }
}
</script>